export default __webpack_public_path__ + "static/media/cm_band_franz.9f0a1f72.jpg";